"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    basicFontSize
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccAudiencePickerErrorStyle = (0, _react.useMemo)(() => {
    const ccAudiencePickerError = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      height: '100%',
      fontSize: basicFontSize
    });
    const ccAudiencePickerErrorImgWrapper = (0, _css.css)({
      flexGrow: 1,
      textAlign: 'center'
    });
    const ccAudiencePickerErrorImg = (0, _css.css)({
      height: pxToRem(140)
    });
    return {
      ccAudiencePickerError,
      ccAudiencePickerErrorImgWrapper,
      ccAudiencePickerErrorImg
    };
  }, [basicFontSize, pxToRem]);
  return {
    'cc-AudiencePicker__error': ccAudiencePickerErrorStyle.ccAudiencePickerError,
    'cc-AudiencePicker__error__image-wrapper': ccAudiencePickerErrorStyle.ccAudiencePickerErrorImgWrapper,
    'cc-AudiencePicker__error__image': ccAudiencePickerErrorStyle.ccAudiencePickerErrorImg
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;